<template>
  <v-card>
    <v-card-title>
      自己評価の推移
      <v-spacer />
    </v-card-title>
    <BarChart class="chart" :chartData="chartData" :options="options" />
  </v-card>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { mapGetters } from "vuex";
import 'chartjs-plugin-colorschemes'
import BarChart from "@/components/BarChart.vue";
import record from '@/store/record';
export default {
  components: {
    BarChart,
  },
  mounted(){
    this.fillData();
  },
  data() {
    return {
      members: [],
      chartData: {
        labels: [],
        datasets: [],
      },
      options: {
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        scales: { 
          yAxes: [
            { ticks: { 
                min: 0,
                max: 5,
                stepSize: 1
              } 
            }
          ] 
        },
        plugins: {
          colorschemes: {
            scheme: 'tableau.Tableau20'
          }
        }
      },
    };
  },
  watch: {
    groupJob(){
      this.fillData()
    },
    groupJobMember(){
      this.fillData();
    }
  },
  computed: {
    ...mapGetters('job', ['groupJob', 'groupJobMember']),
  },
  methods: {
    fillData(){
      this.chartData = {
        labels: this.setLabels(),
        datasets: this.setData()
      }
    },
    setLabels(){
      const labels = [];
      const startDate = moment(this.groupJob.startDate).format('M/DD');
      const finishDate = moment(this.groupJob.finishDate).format('M/DD');
      let labelDate = startDate;
      labels.push(labelDate);
      while(labelDate !== finishDate) {
        labelDate = moment(labelDate).add(1, 'days').format('M/DD');
        labels.push(labelDate);
      } 
      return labels;
    },
    setData(){
      const datasets = []
      // メンバーごとのジョブ記録をデータにセットする
      this.groupJobMember.forEach(groupJobMember => {
        const data = [];
        const recordList = groupJobMember.recordList
        _.orderBy(recordList, (record => record.recordAt), 'desc');
        recordList.forEach(record => {
          const recordData = {
            x: moment.unix(record.recordAt.seconds).format('M/DD'),
            y: record.recordEvaluation
          }
          data.push(recordData);
        })
        // 各メンバーのデータを折れ線グラフのデータの追加する
        const dataset = {
          label: groupJobMember.userName,
          data: data,
          borderWidth: 1,
          fill: false
        }
        datasets.push(dataset);
      })
      return datasets;
    }
  },
};
</script>
